import React from 'react';
import './App.css';
import Bureau from './Pages/Bureau/Bureau';
import { Routes, Route } from 'react-router-dom';
import Chaise from './Pages/Chaise/Chaise';
import Table from './Pages/Table/Table';
import Armoire from './Pages/Armoire/Armoire';
import Payement from './Pages/Mode de payement/Payement';
import Home from './Pages/Home/Home'
import Visiteur from './visiteur/visiteur';
import Bureaux from './admin/pages/products/Bureau/Bureau';
import AjouterBureau from './admin/pages/products/Bureau/AjouterBureau';
import Tables from './admin/pages/products/table/Table';
import AjouterTable from './admin/pages/products/table/AjouterTable';
import Chaises from './admin/pages/products/chaise/Chaises';
import AjouterChaise from './admin/pages/products/chaise/AjouterChaise';
import Armoires from './admin/pages/products/armoire/Armoires';
import AjouterArmoire from './admin/pages/products/armoire/AjouterArmoire';
import BureauDetails from './Pages/BureauDetails/BureauDetails';
import ChaiseDetails from './Pages/ChaiseDetails/ChaiseDetails';
import TableDetails from './Pages/TableDetails/TableDetails';
import ArmoireDetails from './Pages/ArmoireDetails/ArmoireDetails';
import CarouselAdmin from './admin/pages/carousel/CarouselAdmin';
import AjouterCarousel from './admin/pages/carousel/AjouterCarousel';
import Admin from './admin/pages/Admin/Admin';
import AjouterAdmin from './admin/pages/Admin/AjouterAdmin';
import Login from './admin/pages/login/Login';
import Dashburd from './admin/Dashburd';
import Actualite from './admin/pages/Actualite/Actualite';
import AjouterActualite from './admin/pages/Actualite/AjouterActualite';
import Searchpage from './Pages/Searchpage/Searchpage';
import Commande from './admin/pages/Commande/Commande';
import SousCategorieContainer from './section/SousCategorieContainer/SousCategorieContainer';
import Comptoir1 from './admin/pages/products/Comptoir/comptoir';
import AjouterComptoir from './admin/pages/products/Comptoir/AjouterComptoir';
import Comptoir from './Pages/Comptoir/Comptoir';
import ComptoirDetails from './Pages/ComptoirDetails/ComptoirDetails';
import About from './Pages/About/About';
import Politique from './Pages/Politique de confidentialité/Politique';
import Contact from './Pages/Contact/Contact';
import SearchpageAdmin from './admin/pages/SearchpageAdmin/SearchpageAdmin';
import Catégorie from './admin/pages/Catégorie/Catégorie';
import AjouterCatégorie from './admin/pages/Catégorie/AjouterCatégorie';
import Reclamation from './admin/pages/Reclamation/Reclamation';
import SousCatégorie from './admin/pages/Sous-categorie/Sous-Catégorie';
import AjouterSousCatégorie from './admin/pages/Sous-categorie/AjouterSousCatégorie';
import NotFound from './Pages/NotFound/NotFound';
import AdminDashboard from './admin/pages/Dashboard/Dashboard';

function App() {
  return (
    <div className="App ">

      <Routes>
        <Route path='/' element={<Visiteur />} >
          <Route index element={<Home />} />
          <Route path='Bureau' element={<Bureau/>} />
          <Route path='About' element={<About/>} />
          <Route path='Politique-de-confidentialité' element={<Politique/>} />
          <Route path='Contact' element={<Contact/>} />
          <Route path='Chaise' element={<Chaise />} />
          <Route path='Table' element={<Table />} />
          <Route path="COMPTOIR-D'ACCUEIL" element={<Comptoir/>} />
          <Route path='Armoire' element={<Armoire />} />
          <Route path='produits/:resource/:type' element={<SousCategorieContainer />} />
          <Route path='Payement' element={<Payement />} />
          <Route path='/bureau/details/:id' element={<BureauDetails />} />
          <Route path='/chaise/details/:id' element={<ChaiseDetails />} />
          <Route path='/table/details/:id' element={<TableDetails />} />
          <Route path='/armoire/details/:id' element={<ArmoireDetails />} />
          <Route path='/search/:id' element={<Searchpage />} />
          <Route path='/comptoir/details/:id' element={<ComptoirDetails />} />
          <Route path='*' element={<NotFound />} />
        </Route >

        <Route path='/admin' element={<Dashburd/>} >
          <Route index element={<AdminDashboard />} />
          <Route path='Bureaux' element={<Bureaux />} />
          <Route path='Bureaux/ajouter' element={<AjouterBureau />} />
          <Route path='Table' element={<Tables />} />
          <Route path='Table/ajouter' element={<AjouterTable />} />
          <Route path='Chaise' element={<Chaises />} />
          <Route path='Chaise/ajouter' element={<AjouterChaise />} />
          <Route path='Armoire' element={<Armoires />} />
          <Route path='Armoire/ajouter' element={<AjouterArmoire />} />
          <Route path='Carousel' element={<CarouselAdmin />} />
          <Route path='Carousel/ajouter' element={<AjouterCarousel />} />
          <Route path='Registre' element={<Admin />} />
          <Route path='Registre/ajouter' element={<AjouterAdmin />} />
          <Route path='Actualite' element={<Actualite/>} />
          <Route path='Actualite/ajouter' element={<AjouterActualite />} />
          <Route path='Commande' element={<Commande/>} />
          <Route path='Comptoir' element={<Comptoir1/>} />
          <Route path='Comptoir/ajouter' element={<AjouterComptoir />} />
          <Route path='Catégorie' element={<Catégorie/>} />
          <Route path='Catégorie/ajouter' element={<AjouterCatégorie />} />
          <Route path='Sous-Catégorie' element={<SousCatégorie/>} />
          <Route path='Sous-Catégorie/ajouter' element={<AjouterSousCatégorie />} />

          <Route path='Reclamation' element={<Reclamation/>} />

          <Route path='search/:Id' element={<SearchpageAdmin />} />
        </Route>

        <Route path='login' element={<Login />} />

      </Routes>


    </div>


  );
}

export default App;
